import { Component, input } from '@angular/core';
import { RootCauses } from "../../report.constants";

@Component({
  selector: 'app-root-cause-banner',
  imports: [],
  templateUrl: './root-cause-banner.component.html',
})
export class RootCauseBannerComponent {
  rootCauses = input.required<RootCauses[]>();
}
